import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: localStorage.getItem("email") || "",
  uid: localStorage.getItem("uid") || "",
  token: localStorage.getItem("token") || "",
  isLoggedIn: true,
  firstName: "",
  lastName: "",
  fullName: "",
  birthday: "",
  address: "",
  contactNumber: "",
  dateCreated: "",
  memberExpiry: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      localStorage.setItem("email", action.payload.email);
      localStorage.setItem("uid", action.payload.uid);
      state.email = action.payload.email;
      state.uid = action.payload.uid;
      state.isLoggedIn = true;
    },
    setIdToken: (state, action) => {
      localStorage.setItem("token", action.payload);
      state.token = action.payload;
    },
    unsetUser: (state) => {
      localStorage.clear();
      state.email = "";
      state.uid = "";
      state.token = "";
      state.isLoggedIn = false;
      state.userName = "";
      state.firstName = "";
      state.lastName = "";
      state.fullName = "";
      state.birthday = "";
      state.address = "";
      state.contactNumber = "";
      state.dateCreated = "";
      state.memberExpiry = "";
      state.isActive = true;
    },
    setUserDetails: (state, action) => {
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.fullName = action.payload.fullName;
      // state.birthday = action.payload.birthday;
      state.address = action.payload.address;
      state.contactNumber = action.payload.contactNumber;
      state.dateCreated = action.payload.dateCreated;
      state.memberExpiry = action.payload.memberExpiry;
      state.isActive = action.payload.isActive;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setIdToken, setUser, unsetUser, setUserDetails } =
  authSlice.actions;

export default authSlice.reducer;
